/* B01 storefront purchase. Shopify owns prices, stock, cart, checkout and payments. */
(() => {
  'use strict';
  if (window.SaunasB01Commerce) { window.SaunasB01Commerce.scan(document); return; }
  const PENDING = 'saunas_b01_cart_pending_v1';
  const AB_KEYS = ['saunas_ab_experiment','saunas_ab_variant','saunas_ab_session'];
  const EXPERIMENT = 'saunas_lp_2026_10';
  const roots = new WeakMap();
  function init(root) {
    if (roots.has(root)) return;
    const lifetime = new AbortController();
    const on = (el,type,fn) => el?.addEventListener(type,fn,{signal:lifetime.signal});
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const reduced = motion.matches;
    if (!reduced && 'IntersectionObserver' in window) root.classList.add('has-motion');
    const stopMotion = event => { if(event.matches)root.classList.remove('has-motion'); };
    motion.addEventListener?.('change',stopMotion,{signal:lifetime.signal});
    const observers=[];
    root.querySelectorAll('.reveal').forEach(el => {
      if (reduced || !('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
      const o=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');o.unobserve(e.target);}}),{threshold:.08});o.observe(el);observers.push(o);
    });
    const choice=root.querySelector('[data-b01-choice]'),sticky=root.querySelector('.cta-bar');
    if (choice && sticky && 'IntersectionObserver' in window) {
      const o=new IntersectionObserver(es=>{const hidden=es[0]?.isIntersecting;sticky.classList.toggle('is-hidden',hidden);sticky.inert=hidden;sticky.setAttribute('aria-hidden',String(hidden));},{threshold:.05});o.observe(choice);observers.push(o);
    }
    const forms=[...root.querySelectorAll('[data-product-form]')];
    const cartDialog=root.querySelector('[data-cart-dialog]');
    const cartResult=root.querySelector('[data-cart-result]'),cartStatus=root.querySelector('[data-cart-status]');
    const checkout=root.querySelector('[data-checkout]'),reset=root.querySelector('[data-reset-intent]');
    let busy=false,blocked=false,checkoutReady=false,attributesPending=false,attributesSafe=true;
    const added=new Map();let attributesQueue=Promise.resolve();
    let prefix=null;
    try {
      const path=new URL(root.dataset.cartRoot || '/',location.origin);
      if (path.origin===location.origin && path.pathname.endsWith('/') && !path.search && !path.hash &&
          (path.protocol==='https:' || (path.protocol==='http:' && ['localhost','127.0.0.1'].includes(path.hostname)))) prefix=path.pathname;
    } catch (_) {}
    function safeVariant(form) {
      const option=form.querySelector('[data-variant]')?.selectedOptions[0];
      return option && /^\d{8,20}$/.test(option.value) && option.dataset.available==='true' && !option.disabled ? option : null;
    }
    function quantity(form){const text=form.querySelector('[data-quantity]')?.value || '';return /^(?:[1-9]|10)$/.test(text)?Number(text):null;}
    function update(form) {
      const option=safeVariant(form),count=quantity(form),button=form.querySelector('[data-add-cart]');
      const price=option ? Number(option.dataset.price) : NaN;
      const currency=root.querySelector('[data-currency]')?.dataset.currency;
      let formatted='—';
      if (count && Number.isSafeInteger(price) && price>=0 && /^[A-Z]{3}$/.test(currency||'')) {
        try{formatted=new Intl.NumberFormat('ja-JP',{style:'currency',currency}).format(price*count/100);}catch(_){}
      }
      form.querySelector('[data-unit-price]').textContent=option?.dataset.priceLabel || '選択後に表示';
      form.querySelector('[data-subtotal]').textContent=formatted;
      const signature=option && count ? option.value+':'+count : '';
      const complete=added.has(signature);
      button.disabled=busy || blocked || !prefix || root.dataset.commerce!=='true' || !option || !count || formatted==='—';
      button.textContent=complete?'追加済み：カートを確認':busy?'追加結果を確認中…':blocked?'カートの確認が必要です':root.dataset.commerce!=='true'?'購入接続は停止中':'カートに追加';
      form.querySelector('[data-variant]').disabled=busy || blocked;
      form.querySelector('[data-quantity]').disabled=busy || blocked;
    }
    const updateAll=()=>forms.forEach(update);
    function modal(dialog){if(dialog && !dialog.open && typeof dialog.showModal==='function')dialog.showModal();}
    root.querySelectorAll('[data-close-dialog]').forEach(button=>on(button,'click',()=>button.closest('dialog')?.close()));
    root.querySelectorAll('dialog').forEach(dialog=>on(dialog,'click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close();}}));
    function savePending(intent){try{sessionStorage.setItem(PENDING,JSON.stringify(intent));}catch(_){}}
    function erasePending(){try{sessionStorage.removeItem(PENDING);}catch(_){}}
    async function request(suffix,data) {
      if (!prefix || !['cart.js','cart/add.js','cart/update.js'].includes(suffix)) throw new Error('route_unavailable');
      const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),8000);
      try {
        const response=await fetch(prefix+suffix,{method:data?'POST':'GET',credentials:'same-origin',mode:'same-origin',cache:'no-store',
          headers:data?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},
          body:data?JSON.stringify(data):undefined,signal:controller.signal});
        let result=null;try{result=await response.json();}catch(_){}
        return {ok:response.ok,status:response.status,result};
      } finally {clearTimeout(timer);}
    }
    function intentQuantity(cart,intent) {
      if (!Array.isArray(cart?.items)) return null;
      return cart.items.filter(item=>String(item.variant_id)===intent.variant && item.properties?._saunas_b01_intent===intent.request)
        .reduce((sum,item)=>Number.isSafeInteger(item.quantity)&&item.quantity>=0?sum+item.quantity:sum,0);
    }
    function attributesTask() {
      attributesPending=true;attributesSafe=false;if(checkout)checkout.disabled=true;
      attributesQueue=attributesQueue.catch(()=>{}).then(async()=>{
        {
          const result=await request('cart.js');
          if (!result.ok)throw new Error('cart_not_readable');
          const owned=result.result?.attributes;
          if (owned?.saunas_ab_experiment===EXPERIMENT && ['A','B1'].includes(owned?.saunas_ab_variant)) {
            const cleared=await request('cart/update.js',{attributes:Object.fromEntries(AB_KEYS.map(k=>[k,'']))});
            if (!cleared.ok)throw new Error('attributes_not_cleared');
          }
        }
      });
      const task=attributesQueue;
      task.then(()=>{if(task===attributesQueue){attributesPending=false;attributesSafe=true;if(checkout)checkout.disabled=!checkoutReady;}})
        .catch(()=>{if(task===attributesQueue){attributesPending=false;attributesSafe=false;if(checkout)checkout.disabled=true;if(cartStatus)cartStatus.textContent='カート情報を確認できませんでした。カート画面で内容をご確認ください。';}});
      return task;
    }
    function showResult(intent,actual,complete) {
      checkoutReady=complete && actual>0 && root.dataset.commerce==='true';
      if(checkout)checkout.disabled=!checkoutReady || attributesPending || !attributesSafe;
      cartResult.textContent=actual>0?'カートに'+actual+'点追加されています。選択内容と金額をカート画面で確認できます。':'追加結果を確認できませんでした。自動で再送しません。カート画面で内容をご確認ください。';
      cartStatus.textContent=!attributesSafe && actual>0?'カート情報を確認できませんでした。カート画面で内容をご確認ください。':actual>0 && !complete?'指定数量'+intent.quantity+'点と異なります。カート画面で数量を確認してください。':'';
      if(reset)reset.hidden=!blocked;
      modal(cartDialog);
    }
    async function submit(form,event) {
      event.preventDefault();
      const option=safeVariant(form),count=quantity(form);
      if(busy || blocked || !option || !count || !prefix || root.dataset.commerce!=='true')return;
      const signature=option.value+':'+count;
      if(added.has(signature)){showResult(added.get(signature),added.get(signature).quantity,true);return;}
      busy=true;checkoutReady=false;updateAll();
      const intent={request:crypto.randomUUID(),variant:option.value,quantity:count};savePending(intent);
      let outcome=null,cart=null;
      try {
        outcome=await request('cart/add.js',{items:[{id:intent.variant,quantity:intent.quantity,properties:{_saunas_b01_intent:intent.request}}]});
      } catch (_) { /* Result may be ambiguous. Never retry a mutation. */ }
      try {const latest=await request('cart.js');if(latest.ok)cart=latest.result;}catch(_){}
      const actual=intentQuantity(cart,intent);
      if(actual===count){erasePending();added.set(signature,intent);try{await attributesTask();}catch(_){}}
      else if(actual===0 && outcome && !outcome.ok){erasePending();form.querySelector('[data-purchase-status]').textContent='追加できませんでした。販売状態や在庫が変更された可能性があります。';}
      else{blocked=true;form.querySelector('[data-purchase-status]').textContent='追加結果と指定数量を確認してください。自動で再送しません。';}
      busy=false;updateAll();
      if(actual===count || blocked)showResult(intent,actual||0,actual===count && !blocked);
    }
    forms.forEach(form=>{
      on(form,'submit',e=>submit(form,e));
      on(form.querySelector('[data-variant]'),'change',()=>{form.querySelector('[data-purchase-status]').textContent='';update(form);});
      on(form.querySelector('[data-quantity]'),'input',()=>{form.querySelector('[data-purchase-status]').textContent=quantity(form)?'':'数量は1〜10の整数で選んでください。';update(form);});
    });
    on(reset,'click',()=>{erasePending();blocked=false;cartDialog?.close();updateAll();});
    on(root.querySelector('[data-checkout-form]'),'submit',e=>{
      if(!checkoutReady || attributesPending || !attributesSafe || busy || blocked || !prefix || root.dataset.commerce!=='true'){e.preventDefault();return;}
      checkoutReady=false;checkout.disabled=true;
    });
    updateAll();root.classList.add('is-enhanced');
    let pending=null;try{pending=JSON.parse(sessionStorage.getItem(PENDING));}catch(_){}
    if(pending && /^[a-f0-9-]{36}$/.test(pending.request||'') && /^\d{8,20}$/.test(pending.variant||'') && Number.isInteger(pending.quantity) && pending.quantity>=1 && pending.quantity<=10 && prefix) {
      blocked=true;updateAll();
      request('cart.js').then(async r=>{
        const actual=r.ok?intentQuantity(r.result,pending):null;
        if(actual===pending.quantity){blocked=false;erasePending();added.set(pending.variant+':'+pending.quantity,pending);updateAll();try{await attributesTask();}catch(_){}}
        showResult(pending,actual||0,actual===pending.quantity);
      }).catch(()=>showResult(pending,0,false));
    }
    roots.set(root,()=>{lifetime.abort();observers.forEach(o=>o.disconnect());});
  }
  function scan(scope){if(scope.matches?.('[data-saunas-b01]'))init(scope);scope.querySelectorAll?.('[data-saunas-b01]').forEach(init);}
  window.SaunasB01Commerce={scan};scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-saunas-b01]').forEach(root=>roots.get(root)?.()));
})();
